//region block: pre-declaration
//endregion
function _B0___init__impl__6otxhp(b0) {
  return b0;
}
function _B0___get_b0__impl__g161pk($this) {
  return $this;
}
//region block: exports
export {
  _B0___init__impl__6otxhp as _B0___init__impl__6otxhp2jtwm6my41vsz,
  _B0___get_b0__impl__g161pk as _B0___get_b0__impl__g161pk39flv3ku3zckj,
};
//endregion

//# sourceMappingURL=-EndianUtils.mjs.map
